var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 245.572,
    height: 392.421,
    viewBox: "0 0 245.572 392.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8415",
    "data-name": "Path 8415",
    d: "M0,13.77C2.26,0,16.17,0,16.17,0s6.73,13.88,14,28.32S45.02,57.53,47.09,59.91a12.189,12.189,0,0,1,1.46,3.33c3.4,10.15,9.93,40.38,14.73,66.53,3.54,19.23,6.14,36.25,5.88,41.42,0,.66-.07,1.37-.12,2.1-.41,7.43-1.17,18.21-1.79,26.75-.57,7.67-1,13.53-1,13.53L34.59,197.8h0l-19.91-9.92s.92-3.35,2.32-8.56c4.35-16.08,13.37-49.91,14.5-57.51a29.3,29.3,0,0,0-.51-7.93h0c-.61-3.76-1.62-8.28-2.8-13-2-7.77-4.4-16.06-6.32-22.33C20,72.49,18.62,68.32,18.62,68.32Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8423",
    "data-name": "Path 8423",
    d: "M0,44.365l1.25-29,.49-.33c2.47-1.66,13.88-9.15,24.05-12.89,4-1.47,7.81-2.36,10.81-2.1,11.62,1,14.26,7.29,14.26,7.29.75,3.52-2.93,8-8.62,12.57-6,4.83-14.13,9.8-21.69,14C9.65,39.955,0,44.365,0,44.365Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8428",
    "data-name": "Path 8428",
    d: "M0,14.43s2.54-3,18.24-7.72A218.39,218.39,0,0,1,49.84,0l2.53,11.44L54.43,0A67.721,67.721,0,0,1,70.26,8.11L69.02,27.64c-.24,7.47,2.25,32.14,9.75,48.74s4.95,37.21-1.25,39.77c-4.19,1.73-17.26,3.92-25.31,5.17-3.88.6-6.6,1-6.6,1a104.938,104.938,0,0,1-25.17-3.11c-11.74-2.92-19.43-7.08-19.43-8.7,0-1.45,1.69-18.11,3.2-33.06,1.2-11.94,2.28-22.77,2.28-23.88,0-.73-.56-4.4-1.35-9.23h0C3.26,32.71,0,14.43,0,14.43Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-151",
    transform: "translate(168.451 423.738) rotate(-161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8411",
    "data-name": "Path 8411",
    d: "M8.78,47.319s-4.11-8.79-6.16-11S0,28.849,0,28.849v-4.11L2.24,20l3,.75,2.39-7.1S12.51.379,20.93.009s2.63,10.31.93,17.99-2.26,15.7-.94,20S8.78,47.319,8.78,47.319Z",
    transform: "translate(68.077 9.681)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8412",
    "data-name": "Path 8412",
    d: "M0,13.77C2.26,0,16.17,0,16.17,0s6.73,13.88,14,28.32S45.02,57.53,47.09,59.91a12.189,12.189,0,0,1,1.46,3.33c3.4,10.15,9.93,40.38,14.73,66.53,3.54,19.23,6.14,36.25,5.88,41.42,0,.66-.07,1.37-.12,2.1-.41,7.43-1.17,18.21-1.79,26.75-.57,7.67-1,13.53-1,13.53L34.59,197.8h0l-19.91-9.92s.92-3.35,2.32-8.56c4.35-16.08,13.37-49.91,14.5-57.51a29.3,29.3,0,0,0-.51-7.93h0c-.61-3.76-1.62-8.28-2.8-13-2-7.77-4.4-16.06-6.32-22.33C20,72.49,18.62,68.32,18.62,68.32Z",
    transform: "translate(74.377 39.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4035",
    "data-name": "Group 4035",
    transform: "translate(74.377 39.68)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8413",
    "data-name": "Path 8413",
    d: "M0,13.77C2.26,0,16.17,0,16.17,0s6.73,13.88,14,28.32S45.02,57.53,47.09,59.91a12.189,12.189,0,0,1,1.46,3.33c3.4,10.15,9.93,40.38,14.73,66.53-3.54,2.4-6.74,5.45-7.65,9-2.3,9-2.36,10.81-2.36,10.81l2.36,4.4-7.08-2L30.96,113.91h0c-.61-3.76-1.62-8.28-2.8-13-2-7.77-4.4-16.06-6.32-22.33-1.87-6.06-3.25-10.23-3.25-10.23Z",
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8414",
    "data-name": "Path 8414",
    d: "M0,22s.92-3.35,2.32-8.56c25.44-12.1,42.74-9,42.74-9L40.98,0c3.91.59,9.65,4.55,13.41,7.44-.41,7.43-1.17,18.21-1.79,26.75-9-.34-21.34-1-32.68-2.24h0Z",
    transform: "translate(14.62 165.89)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8416",
    "data-name": "Path 8416",
    d: "M0,13.77C2.26,0,16.17,0,16.17,0s6.73,13.88,14,28.32S45.02,57.53,47.09,59.91a12.189,12.189,0,0,1,1.46,3.33c3.4,10.15,9.93,40.38,14.73,66.53,3.54,19.23,6.14,36.25,5.88,41.42,0,.66-.07,1.37-.12,2.1-.41,7.43-1.17,18.21-1.79,26.75-.57,7.67-1,13.53-1,13.53L34.59,197.8h0l-19.91-9.92s.92-3.35,2.32-8.56c4.35-16.08,13.37-49.91,14.5-57.51a29.3,29.3,0,0,0-.51-7.93h0c-.61-3.76-1.62-8.28-2.8-13-2-7.77-4.4-16.06-6.32-22.33C20,72.49,18.62,68.32,18.62,68.32Z",
    transform: "translate(74.377 39.68)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8417",
    "data-name": "Path 8417",
    d: "M0,50.24C1.18,36.32,3.62,15.54,8.33,0c7.18,14.33,14.85,29.21,16.92,31.59a12.191,12.191,0,0,1,1.46,3.33L6.32,72.57C4.36,64.8,1.92,56.51,0,50.24Z",
    transform: "translate(96.187 68.01)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8418",
    "data-name": "Path 8418",
    d: "M44.18,21.41c-.84,7.48-15.82,2.26-20.83,3.37a24.061,24.061,0,0,0-8.77,4.11L0,25.89S.46,10.18,2.23,6.6A33.34,33.34,0,0,1,6.47,0L20.52,1.12l.67,2.74,5.92,1S44.79,16.04,44.18,21.41Z",
    transform: "translate(132.927 0.82)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8419",
    "data-name": "Path 8419",
    d: "M37.741,23.44c-2.39,2.65-8.78-1.74-13.37-5.1a58.637,58.637,0,0,1-8-6.7L8.971,9.4l.11-2.23S-2.189,3.01.381.77s14.05,1.12,14.05,1.12l.67,2.74,5.92,1S42.511,18.15,37.741,23.44Z",
    transform: "translate(139.006 0)",
    fill: "#757575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8420",
    "data-name": "Path 8420",
    d: "M3.774,224.96s-5-22-3.49-41.56,30.39-92.47,32.39-101.59S56.674,0,56.674,0s12.11,8.94,22.32,6.88c0,0-4.79,23.33-7.11,32.86s-7.18,32.79-7,38.11-10.65,24.18-8.22,26.95-7.73,60-8.13,69.53-13.22,15.68-13.22,15.68",
    transform: "translate(75.693 20.87)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8421",
    "data-name": "Path 8421",
    d: "M0,44.365l1.25-29,.49-.33c2.47-1.66,13.88-9.15,24.05-12.89,4-1.47,7.81-2.36,10.81-2.1,11.62,1,14.26,7.29,14.26,7.29.75,3.52-2.93,8-8.62,12.57-6,4.83-14.13,9.8-21.69,14C9.65,39.955,0,44.365,0,44.365Z",
    transform: "translate(151.937 283.225)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4036",
    "data-name": "Group 4036",
    transform: "translate(151.937 283.225)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8422",
    "data-name": "Path 8422",
    d: "M0,12.89C2.47,11.23,13.88,3.74,24.05,0a91.509,91.509,0,0,1,6.07,10.51c2,4.36,6.26,6.37,10.38,7.25-6,4.83-14.13,9.8-21.69,14-1.26-9.22-9.47-14.51-9.47-14.51,2.38,5.49,0,17.73-1.54,12.46C6.81,26.2,2.71,18.02,0,12.89Z",
    transform: "translate(1.7 2.175)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8424",
    "data-name": "Path 8424",
    d: "M0,44.365l1.25-29,.49-.33c2.47-1.66,13.88-9.15,24.05-12.89,4-1.47,7.81-2.36,10.81-2.1,11.62,1,14.26,7.29,14.26,7.29.75,3.52-2.93,8-8.62,12.57-6,4.83-14.13,9.8-21.69,14C9.65,39.955,0,44.365,0,44.365Z",
    transform: "translate(151.937 283.225)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8425",
    "data-name": "Path 8425",
    d: "M0,14.43s2.54-3,18.24-7.72A218.39,218.39,0,0,1,49.84,0l2.53,11.44L54.43,0A67.721,67.721,0,0,1,70.26,8.11L69.02,27.64c-.24,7.47,2.25,32.14,9.75,48.74s4.95,37.21-1.25,39.77c-4.19,1.73-17.26,3.92-25.31,5.17-3.88.6-6.6,1-6.6,1a104.938,104.938,0,0,1-25.17-3.11c-11.74-2.92-19.43-7.08-19.43-8.7,0-1.45,1.69-18.11,3.2-33.06,1.2-11.94,2.28-22.77,2.28-23.88,0-.73-.56-4.4-1.35-9.23h0C3.26,32.71,0,14.43,0,14.43Z",
    transform: "translate(74.377 211.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4037",
    "data-name": "Group 4037",
    transform: "translate(74.377 211.44)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8426",
    "data-name": "Path 8426",
    d: "M2.28,9.23C2.28,8.5,1.72,4.83.93,0,9.18,7.26,9.22,22.09,9.22,22.09l-3.5-.22c4.34,2.71,3.84,16.56,2.71,13.33s-4.67-2.21-4.67-2.21L0,33.11C1.2,21.17,2.28,10.34,2.28,9.23Z",
    transform: "translate(4.25 44.32)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8427",
    "data-name": "Path 8427",
    d: "M9.92,44.83l-5-15.13L37.31,0l.89,3.62L53.65,32.9,47.14,44.83l4.51,4.67s-7,9.45-14.88,14.77c-3.88.6-6.6,1-6.6,1A104.939,104.939,0,0,1,5,62.16c-2.69-4-5-15.58-5-15.58Z",
    transform: "translate(15.43 57.05)",
    fill: "rgba(0,0,0,0.7)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8429",
    "data-name": "Path 8429",
    d: "M0,14.43s2.54-3,18.24-7.72A218.39,218.39,0,0,1,49.84,0l2.53,11.44L54.43,0A67.721,67.721,0,0,1,70.26,8.11L69.02,27.64c-.24,7.47,2.25,32.14,9.75,48.74s4.95,37.21-1.25,39.77c-4.19,1.73-17.26,3.92-25.31,5.17-3.88.6-6.6,1-6.6,1a104.938,104.938,0,0,1-25.17-3.11c-11.74-2.92-19.43-7.08-19.43-8.7,0-1.45,1.69-18.11,3.2-33.06,1.2-11.94,2.28-22.77,2.28-23.88,0-.73-.56-4.4-1.35-9.23h0C3.26,32.71,0,14.43,0,14.43Z",
    transform: "translate(74.377 211.44)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8430",
    "data-name": "Path 8430",
    d: "M24.84,71.37s10.45-2.52,23.71-15.93l-4.51-5.37,4.51-7.66s-7.84-24.85-13.82-34L35.85,0,6.39,36.15l4,11.94L0,50.65,2.43,64.82S9.43,75.43,24.84,71.37Z",
    transform: "translate(92.957 266.49)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8431",
    "data-name": "Path 8431",
    d: "M22.79,55.89s6.73-8.34,8.23-17.43S24.66,0,24.66,0,12.33,35,0,55.89Z",
    transform: "translate(102.087 277.85)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8432",
    "data-name": "Path 8432",
    d: "M10.18,43.57,7.38,33.48,9.03,9.75,6.63,0,3,9.79,5,32.92l-5,9.9S7.04,45.06,10.18,43.57Z",
    transform: "translate(120.117 277.85)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8433",
    "data-name": "Path 8433",
    d: "M30.73,13.45s-4,9.6-11.36,13.4A16.37,16.37,0,0,1,5,26.85L0,20.42,15.44,0l8.47,7.23,7.11-4.24S32.13,10.65,30.73,13.45Z",
    transform: "translate(102.067 313.32)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8434",
    "data-name": "Path 8434",
    d: "M0,16.63,16.67,0s2.06,6.17,3.18,7.85c.22.33.55.86.94,1.51,1.59,2.67,4.17,7.27,4.17,7.27l-5.88,5.3L4.29,35.25V24.91C4.29,24.03,0,16.63,0,16.63Z",
    transform: "translate(108.967 322.54)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8435",
    "data-name": "Path 8435",
    d: "M8.1,94.2l36-46.82a4.73,4.73,0,0,0,.87-3.83l-8.86-42.09A1.85,1.85,0,0,0,32.777.8L.817,47.528a4.72,4.72,0,0,0-.79,3.16l4.79,42.59a1.85,1.85,0,0,0,3.28.92Z",
    transform: "translate(14.82 105.702)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8436",
    "data-name": "Path 8436",
    d: "M33.873,11.359c-.56-6.82-6.07-12.62-27.28-11.12,0,0-6.07,4.58-6.54,9.44s2.34,7,2.34,7l14.1,3.09a11.269,11.269,0,0,0,4,1.86",
    transform: "translate(168.924 279.232)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8437",
    "data-name": "Path 8437",
    d: "M1.5,15.79s7.85.1,10-6.54S6.5,0,6.5,0,.661,2.15.1,7.9,1.5,15.79,1.5,15.79Z",
    transform: "translate(169.816 280.12)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8438",
    "data-name": "Path 8438",
    d: "M0,10.936s1.47,1.2,2.12,1.58,4.92.42,7.6-.78c3.32-1.47,5.88-8.35.56-10.72s-5.42.15-5.42.15Z",
    transform: "translate(165.987 281.445)",
    fill: "#962cc6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8439",
    "data-name": "Path 8439",
    d: "M0,10.82a82.329,82.329,0,0,1,8.09,1.7s7.56,0,8-5.17c.39-4.17-1.48-5.91-6.9-7.35Z",
    transform: "translate(158.937 280.12)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8440",
    "data-name": "Path 8440",
    d: "M15.726,19.065c-4.86,1.12-13.08-3-14.92-4.48-1.12-.9-.9-9.39-.38-10.53.94-2.05,5.18-2.86,5.18-2.86,3.33-1.93,7.58-1.2,9-.06,1,.79,1.09,5,1.09,5s6.55-.36,7.5,3.46",
    transform: "translate(145.75 271.706)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8441",
    "data-name": "Path 8441",
    d: "M3.91.372A3.39,3.39,0,0,0,0,.962",
    transform: "translate(157.567 277.478)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8442",
    "data-name": "Path 8442",
    d: "M3,2.43S2.27,0,0,0",
    transform: "translate(155.937 275.2)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8443",
    "data-name": "Path 8443",
    d: "M5.771,0A8.88,8.88,0,0,0,.051,3.79c-.26.73.56,6.11.56,6.11",
    transform: "translate(151.796 271.97)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8444",
    "data-name": "Path 8444",
    d: "M5.643,0A10.69,10.69,0,0,0,.173,3.57c-.39.71,0,7.85,0,7.85",
    transform: "translate(148.503 271.88)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8445",
    "data-name": "Path 8445",
    d: "M0,.941c0-.65,1.78-1.06,3.86-.91s3.73.8,3.69,1.45-1.78,1.07-3.86.92S-.049,1.591,0,.941Z",
    transform: "translate(167.036 292.609)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8446",
    "data-name": "Path 8446",
    d: "M14.49,94.82H0L26.93,0H42.91l2.7,39.07Z",
    transform: "translate(6.787 105.79)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8447",
    "data-name": "Path 8447",
    d: "M8.057,94.2l36-46.82a4.7,4.7,0,0,0,.88-3.83l-8.86-42.09A1.85,1.85,0,0,0,32.747.8L.817,47.528a4.72,4.72,0,0,0-.79,3.16l4.72,42.59a1.85,1.85,0,0,0,3.31.92Z",
    transform: "translate(0 105.702)",
    fill: "#757575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8448",
    "data-name": "Path 8448",
    d: "M16.94.3s1.37,8.35,0,11.53S6.6,24.781,4.61,24.441,0,17.621,0,17.621s1.38-3.49,3.49-3.37c0,0,.32,2.37,1.7,2.74s4.74-4.07,6.1-6.85c1-2.11-.26-7.35-.26-7.35S13.22-1.089,16.94.3Z",
    transform: "translate(26.097 169.38)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8449",
    "data-name": "Path 8449",
    d: "M5.429,29.974s-5.8-15.76-5.41-18.54S3.589.964,4.8.434a6,6,0,0,1,5.44.49s-2.52,3.37,0,6.54c.93,1.17,5.65-4.85,5.65-4.85s4.49.93,4.49,3.73-1.78,8-2.48,11.21a33.149,33.149,0,0,1-1.44,5l1.44,4.74Z",
    transform: "translate(27.148 178.626)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8450",
    "data-name": "Path 8450",
    d: "M45.47,120.912s8.21-14.15,6.85-35.55c0,0-15.7-27.45-18.69-33.12s-6.35-17.26-7.47-21-7.28-16.45-9.52-26.16L15.7.422S4.49-1.7,0,3.562c0,0,14.2,48.6,14.2,50.85s4.86,11,4.86,11S35.25,104.822,45.47,120.912Z",
    transform: "translate(29.957 201.018)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8451",
    "data-name": "Path 8451",
    d: "M0,1.813c1.79,1.06,5.4-3.05,7.15-1.43",
    transform: "translate(37.387 184.297)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8452",
    "data-name": "Path 8452",
    d: "M5.83.889s-1.49-2-2.49,0-1.7,1.08-3.34,3",
    transform: "translate(28.237 182.421)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8453",
    "data-name": "Path 8453",
    d: "M12,12.42S4.47,3.8,0,0",
    transform: "translate(123.347 199.02)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    x1: 11.13,
    y1: 5.41,
    transform: "translate(124.217 195.2)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8454",
    "data-name": "Path 8454",
    d: "M0,5.65S10.86,7.4,26.4,0",
    transform: "translate(90.827 201.03)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8455",
    "data-name": "Path 8455",
    d: "M4.73,10.76S1.18,8.31,0,0",
    transform: "translate(127.617 114.92)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8456",
    "data-name": "Path 8456",
    d: "M18,0S10.78,4.58,0,3",
    transform: "translate(133.327 37.03)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8457",
    "data-name": "Path 8457",
    d: "M2.076,36.18S-.814,12.18.226,0",
    transform: "translate(126.731 230.3)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8458",
    "data-name": "Path 8458",
    d: "M7.67,10.89S6.04,3.42,0,0",
    transform: "translate(80.517 283.3)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8459",
    "data-name": "Path 8459",
    d: "M5,.07A11.669,11.669,0,0,0,0,.61",
    transform: "translate(79.347 281.26)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8460",
    "data-name": "Path 8460",
    d: "M5.28,9.16A48,48,0,0,0,0,0",
    transform: "translate(156.197 296.64)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8461",
    "data-name": "Path 8461",
    d: "M4.16,5.42S2.61,5.23,0,0",
    transform: "translate(181.717 298.19)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8462",
    "data-name": "Path 8462",
    d: "M0,15.92S2.09,5.08,12.52,0c1.59,2.67,4.17,7.27,4.17,7.27l-5.88,5.3C7.14,14.68,3.24,16.1,0,15.92Z",
    transform: "translate(117.227 331.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8463",
    "data-name": "Path 8463",
    d: "M4.131,17.646a28.39,28.39,0,0,1,1.71-4.85c2.19-4.49,9.77-10.66,15.43-12.74,2-.72,9.25,5.54,14,14.63,1.22,2.34,1.39,8.22,2.85,10.5,3.5,5.47,3.51,10.1,2.64,15-3,17.19-33.43,20.12-37.92,12.77-2.16-3.56-5.59-13.75,1-28.78",
    transform: "translate(111.936 333.744)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8464",
    "data-name": "Path 8464",
    d: "M7.78,0S2.97,2,0,0",
    transform: "translate(132.797 361.78)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8465",
    "data-name": "Path 8465",
    d: "M0,0S3.24,2.36,5.38,1.89",
    transform: "translate(146.557 361.16)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8466",
    "data-name": "Path 8466",
    d: "M.082,1.687c-.21-.8,0-1.55.46-1.67s1,.42,1.23,1.22,0,1.55-.46,1.67S.292,2.487.082,1.687Z",
    transform: "translate(134.835 356.644)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8467",
    "data-name": "Path 8467",
    d: "M.086,1.687c-.22-.8,0-1.55.46-1.67s1,.42,1.22,1.22,0,1.55-.46,1.67S.3,2.477.086,1.687Z",
    transform: "translate(145.631 356.334)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8468",
    "data-name": "Path 8468",
    d: "M3.3,10.65c-.56-1,1.87-7.41,1.93-8.28S4.23.25,2.12.13.44.25,0,0",
    transform: "translate(140.887 347.45)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8469",
    "data-name": "Path 8469",
    d: "M7.78.011S3.11-.209,0,1.351",
    transform: "translate(133.107 343.8)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8470",
    "data-name": "Path 8470",
    d: "M19.971,19.13l.87-5.73s-8-5.73-8.22-7.35a7.26,7.26,0,0,1,0-2.62l-1.74-1.62s-.75,6.26-2.25,7.11S4.351,0,4.351,0,.031,5.61,0,11.74c-.07,14.61,3.4,22.17,9.26,25a8.9,8.9,0,0,0,3.61,2.83c2.24.87,25.43-3.41,27.48-2.83a20.749,20.749,0,0,1,4.53,2.2V33.59l5.16,1.35s-.67-8.35-4.66-11l4.66.75a46.78,46.78,0,0,0-6-6.32C41.4,16.26,31.431,14.52,19.971,19.13Z",
    transform: "translate(108.896 353.74)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8471",
    "data-name": "Path 8471",
    d: "M8.561,8.934s-4.85,5.6-6.72,4.73S-.529,9.3.591,7.184s4.11-10,6.85-6.13",
    transform: "translate(108.965 351.747)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8472",
    "data-name": "Path 8472",
    d: "M17,0V3.57S4.93,4.16,1,6.14L0,3.07",
    transform: "translate(89.847 241.11)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8473",
    "data-name": "Path 8473",
    d: "M0,0V3.06A10.61,10.61,0,0,1,6.16,6.13V3.06",
    transform: "translate(135.347 241.11)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChar);
export default __webpack_public_path__ + "static/media/char.a33d402d33cab252a19ebe5cbe9c7c73.svg";
export { ForwardRef as ReactComponent };